import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import {
  FaCog,
  FaDollarSign,
  FaClock,
  FaStar,
  FaChevronDown,
  FaTimes,
} from "react-icons/fa";
import "./navbar.css";

function Sidebar({ isOpen, onClose }) {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  const closeDropdown = () => setActiveDropdown(null);

  return (
    <aside className={`sidebar ${isOpen ? "open" : ""}`}>
      <button
        className="sidebar-close-button"
        onClick={onClose}
        aria-label="Close sidebar"
      >
        <FaTimes />
      </button>
      <ul className="sidebar-nav">
        <li className="sidebar-item">
          <Link className="sidebar-link" to="/" onClick={onClose}>
            Home
          </Link>
        </li>
        <li
          className={`sidebar-item dropdown ${
            activeDropdown === "services" ? "active" : ""
          }`}
        >
          <button
            className="sidebar-link dropdown-toggle"
            onClick={() => toggleDropdown("services")}
            aria-expanded={activeDropdown === "services"}
          >
            Services <FaChevronDown className="dropdown-icon" />
          </button>
          <ul
            className={`dropdown-menu ${
              activeDropdown === "services" ? "show" : ""
            }`}
          >
            <li>
              <Link className="dropdown-item" to="/services" onClick={onClose}>
                <FaCog className="dropdown-item-icon" /> All Services
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item"
                to="/what-we-do"
                onClick={onClose}
              >
                <FaClock className="dropdown-item-icon" /> What We Do
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/pricing" onClick={onClose}>
                <FaDollarSign className="dropdown-item-icon" /> Pricing
              </Link>
            </li>
          </ul>
        </li>
        <li
          className={`sidebar-item dropdown ${
            activeDropdown === "about" ? "active" : ""
          }`}
        >
          <button
            className="sidebar-link dropdown-toggle"
            onClick={() => toggleDropdown("about")}
            aria-expanded={activeDropdown === "about"}
          >
            About <FaChevronDown className="dropdown-icon" />
          </button>
          <ul
            className={`dropdown-menu ${
              activeDropdown === "about" ? "show" : ""
            }`}
          >
            <li>
              <HashLink
                className="dropdown-item"
                smooth
                to="/#who-sect"
                onClick={onClose}
              >
                <FaCog className="dropdown-item-icon" /> Who We Are
              </HashLink>
            </li>
            <li>
                <Link
                  className="dropdown-item"
                  onClick={onClose}
                  to="/how-it-works"
                >
                 <FaCog className="dropdown-item-icon" /> How It Works
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item"
                  onClick={onClose}
                  to="/our-story"
                >
                 <FaStar className="dropdown-item-icon" /> Our Story
                </Link>
              </li>
            <li>
              <Link className="dropdown-item" to="/guarantee" onClick={onClose}>
                <FaStar className="dropdown-item-icon" /> Our Guarantee
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item"
                to="/testimonials"
                onClick={onClose}
              >
                <FaStar className="dropdown-item-icon" /> Reviews
              </Link>
            </li>
          </ul>
        </li>
        <li className="sidebar-item">
          <Link className="sidebar-link" to="/contact" onClick={onClose}>
            Contact
          </Link>
        </li>
        <li className="sidebar-item">
          <Link className="sidebar-link" to="/careers" onClick={onClose}>
            Careers
          </Link>
        </li>
      </ul>
    </aside>
  );
}

export default Sidebar;
